import { BASE_ATTRIBUTES } from '../enums/base-attributes'
import { type LookupNode, type Lookups } from '../model/attributes-lookup'
import { type Attribute, type Variant } from '../model/product.model'

export function mapVariants(variants: Variant[]): Lookups {
  const lookups: Lookups = {}

  const sequences = variants.map(v => v.attributes)

  if (sequences.length === 0) return lookups

  const reference = sequences[0]

  const orderedAttrs = (() => {
    const costAttr = reference.find(a => a.id === BASE_ATTRIBUTES.cost)
    const others = reference.filter(a => a.id !== BASE_ATTRIBUTES.cost)
    return costAttr ? [...others, costAttr] : reference
  })()

  const buildTree = (attrs: Attribute[], index = 0): LookupNode => {
    const attr = attrs[index]
    const node: LookupNode = {
      id: attr.id,
      name: attr.name,
      children: {},
    }
    if (attr.id === BASE_ATTRIBUTES.cost) {
      node.cost = Number(attr.value)
    }
    if (index < attrs.length - 1) {
      const next = attrs[index + 1]
      node.children[next.id] = buildTree(attrs, index + 1)
    }

    return node
  }

  const root = buildTree(orderedAttrs)
  lookups[root.id] = root

  return lookups
}

export function buildValueLookup(variants: Variant[]) {
  const map: Record<number, Set<string>> = {}

  for (const variant of variants) {
    for (const attr of variant.attributes) {
      if (!map[attr.id]) map[attr.id] = new Set()
      if (attr.value) map[attr.id].add(attr.value)
    }
  }

  return Object.fromEntries(
    Object.entries(map).map(([id, set]) => [
      id,
      Array.from(set as Set<string>),
    ]),
  ) as Record<number, string[]>
}
